var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['secondary-pill-button', _vm.colour, { 'secondary-pill-button-disabled': _vm.disabled}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.emitClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }